import { TableConfig } from '@shared/interfaces/table/table-config';
import { EstimationGroupMethodDto } from '@app/api/dmc';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const veeMethodsTable: TableConfig<EstimationGroupMethodDto> = {
  columns: [
    {
      title: 'vee.details.priority',
      key: 'sortorder',
      width: 75,
    },
    {
      title: 'vee.details.method',
      key: 'method',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        ControlMeter: 'enum.estimationmethod.controlmeter',
        SameAsDayBefore: 'enum.estimationmethod.sameasdaybefore',
        SameAsSevenDaysBefore: 'enum.estimationmethod.sameassevendaysbefore',
        SameAs1MonthBefore: 'enum.estimationmethod.sameas1monthbefore',
        GhostMeter: 'enum.estimationmethod.ghostmeter',
        ZeroValueMeteringPointDisconnected: 'enum.estimationmethod.zerovaluemeteringpointdisconnected',
        ZeroValueInsideDay: 'enum.estimationmethod.zerovalueinsideday',
        ZeroValueMeterChange: 'enum.estimationmethod.zerovaluemeterchange',
        AdvancedVEE: 'enum.estimationmethod.advancedvee',
        NotSpecified: 'enum.estimationmethod.notspecified'
      }
    },
    {
      title: 'vee.details.sendData',
      key: 'estimationMethod',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        estimated: 'common.no',
        asread: 'common.yes',
        notspecified: 'common.no',
      }
    },
  ]
}
